export const saveLocalStorageData = (key: string, data: any) => {
  localStorage.setItem(key, JSON.stringify(data));
};
export const getLocalStorageData = (key: string): any => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};
